import React from "react";
import { withRouter } from "react-router-dom";
import InputField from "../../components/inputs/inputField";
import SelectField from "../../components/inputs/selectField";
import ToggleField from "../../components/inputs/toggleField";
import LoadingWizard from "../../components/spinner/wizard";
import API from "../../utils/API";
import FieldModal from "../../components/modals/fieldModal";


function ValidateEmail(mail) {
    var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (mail.match(mailformat)) {
        return true;
    } else {
        return false;
    }
}
class Integrations extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            authenticating: props.integrationToken ? true : false,
            requiredDetailsModalOpen: false,
            selectedIntegrationIndex: null,
            requiredFieldValues: {},
            fieldValues: {},
            nestedFieldValues: {},
            invalidBlacklistEmails: false,
            customFieldsSchema: [],
            userCredInputValues: {},
            credentialsModalOpen: false,
            customFieldsModalOpen: false,
            openDropdownIndex: null,
        }
    }

    componentDidMount() {
        if (this.props.integrationToken) {

            let searchParams = new URLSearchParams(window.location.href.substring(window.location.href.indexOf('?')));
            const integrationId = searchParams.get('integration');
            if (integrationId) {
                const integrationIndex = this.props.integrations.findIndex(i => i.identifier == integrationId);
                const integration = this.props.integrations[integrationIndex];
                if (integration && integration.links && integration.links.authorize) {
                    API().get(`Organizations/${this.props.orgId}/integrations/${integrationId}/auth?token=${this.props.integrationToken}`).then(res => {
                        if (res.data && res.data.success) {
                            this.props.toggleIntegration(integrationIndex, true, true);
                            this.setState({ authenticating: false });
                        }
                    }).catch(err => {
                        console.log(err);
                        //navigate to integrations page
                        window.location.href = '/admin/account/integrations/all';

                    });
                }
            }
        }
    }



    initializeFieldValues = (integration) => {
        const requiredFieldValues = {};
        if (integration.requiredFields) {
            integration.requiredFields.forEach(field => {
                requiredFieldValues[field.id] = field.value || '';
            });
        }
        const fieldValues = {};
        const nestedFieldValues = {};
        if (integration.fields) {
            integration.fields.forEach(field => {
                fieldValues[field.id] = field.value || '';
                // Initialize nested field values if the field has nested options
                if (field.type === 'picklist' && field.nestedOptions) {
                    nestedFieldValues[field.id] = field.nestedValue || '';
                }
            });
        }
        // Load schema data directly from customFields
        const customFieldsSchema = integration.customFields ? (Array.isArray(integration.customFields) ? integration.customFields : Object.values(integration.customFields)) : [];

        // Populate user cred input values from the pre-filled values returned by the GET
        const userCredInputValues = {};
        if (integration.userCredInputs) {
            integration.userCredInputs.forEach(input => {
                userCredInputValues[input.key] = input.value || '';
            });
        }

        return { requiredFieldValues, fieldValues, nestedFieldValues, customFieldsSchema, userCredInputValues };
    }

    addCustomFieldToSchema = () => {
        const newField = {
            label: '',
            value: '',
            type: 'text',
            required: false
        };
        this.setState({
            customFieldsSchema: [...this.state.customFieldsSchema, newField]
        });
    }

    updateCustomFieldSchema = (index, field, value) => {
        const customFieldsSchema = [...this.state.customFieldsSchema];
        customFieldsSchema[index][field] = value;
        this.setState({ customFieldsSchema });
    }

    addOptionToNestedSection = (fieldIndex) => {
        const customFieldsSchema = [...this.state.customFieldsSchema];
        if (!customFieldsSchema[fieldIndex].options) {
            customFieldsSchema[fieldIndex].options = [];
        }
        customFieldsSchema[fieldIndex].options.push({
            label: '',
            type: 'text'
        });
        this.setState({ customFieldsSchema });
    }

    updateNestedSectionOption = (fieldIndex, optionIndex, field, value) => {
        const customFieldsSchema = [...this.state.customFieldsSchema];
        customFieldsSchema[fieldIndex].options[optionIndex][field] = value;
        this.setState({ customFieldsSchema });
    }

    removeNestedSectionOption = (fieldIndex, optionIndex) => {
        const customFieldsSchema = [...this.state.customFieldsSchema];
        customFieldsSchema[fieldIndex].options.splice(optionIndex, 1);
        this.setState({ customFieldsSchema });
    }

    addTriggerOption = (fieldIndex, triggerKey) => {
        const customFieldsSchema = [...this.state.customFieldsSchema];
        if (!customFieldsSchema[fieldIndex].triggerOptions) {
            customFieldsSchema[fieldIndex].triggerOptions = {};
        }
        if (triggerKey.includes('_')) {
            // Adding an option to a select trigger
            const parts = triggerKey.split('_');
            const optionLabel = parts.slice(0, -1).join('_');
            const triggerIndex = parseInt(parts[parts.length - 1]);
            if (customFieldsSchema[fieldIndex].triggerOptions[optionLabel] &&
                customFieldsSchema[fieldIndex].triggerOptions[optionLabel][triggerIndex]) {
                if (!customFieldsSchema[fieldIndex].triggerOptions[optionLabel][triggerIndex].options) {
                    customFieldsSchema[fieldIndex].triggerOptions[optionLabel][triggerIndex].options = [];
                }
                customFieldsSchema[fieldIndex].triggerOptions[optionLabel][triggerIndex].options.push({
                    label: ''
                });
            }
        } else {
            // Adding a new trigger
            if (!customFieldsSchema[fieldIndex].triggerOptions[triggerKey]) {
                customFieldsSchema[fieldIndex].triggerOptions[triggerKey] = [];
            }
            customFieldsSchema[fieldIndex].triggerOptions[triggerKey].push({
                label: '',
                id: '',
                type: 'text'
            });
        }
        this.setState({ customFieldsSchema });
    }

    updateTriggerOption = (fieldIndex, triggerKey, optionIndex, field, value) => {
        const customFieldsSchema = [...this.state.customFieldsSchema];
        if (triggerKey.includes('_')) {
            // Updating an option within a select trigger
            const parts = triggerKey.split('_');
            const optionLabel = parts.slice(0, -1).join('_');
            const triggerIndex = parseInt(parts[parts.length - 1]);
            if (customFieldsSchema[fieldIndex].triggerOptions[optionLabel] &&
                customFieldsSchema[fieldIndex].triggerOptions[optionLabel][triggerIndex] &&
                customFieldsSchema[fieldIndex].triggerOptions[optionLabel][triggerIndex].options) {
                customFieldsSchema[fieldIndex].triggerOptions[optionLabel][triggerIndex].options[optionIndex][field] = value;
            }
        } else {
            // Updating a trigger itself
            if (field === 'type' && value === 'select') {
                // Initialize options array when type changes to select
                customFieldsSchema[fieldIndex].triggerOptions[triggerKey][optionIndex].options = customFieldsSchema[fieldIndex].triggerOptions[triggerKey][optionIndex].options || [];
            }
            customFieldsSchema[fieldIndex].triggerOptions[triggerKey][optionIndex][field] = value;
        }
        this.setState({ customFieldsSchema });
    }

    removeTriggerOption = (fieldIndex, triggerKey, optionIndex) => {
        const customFieldsSchema = [...this.state.customFieldsSchema];
        if (triggerKey.includes('_')) {
            // Removing an option from a select trigger
            const parts = triggerKey.split('_');
            const optionLabel = parts.slice(0, -1).join('_');
            const triggerIndex = parseInt(parts[parts.length - 1]);
            if (customFieldsSchema[fieldIndex].triggerOptions[optionLabel] &&
                customFieldsSchema[fieldIndex].triggerOptions[optionLabel][triggerIndex] &&
                customFieldsSchema[fieldIndex].triggerOptions[optionLabel][triggerIndex].options) {
                customFieldsSchema[fieldIndex].triggerOptions[optionLabel][triggerIndex].options.splice(optionIndex, 1);
            }
        } else {
            // Removing a trigger
            customFieldsSchema[fieldIndex].triggerOptions[triggerKey].splice(optionIndex, 1);
        }
        this.setState({ customFieldsSchema });
    }

    moveFieldUp = (index) => {
        if (index > 0) {
            const customFieldsSchema = [...this.state.customFieldsSchema];
            const temp = customFieldsSchema[index];
            customFieldsSchema[index] = customFieldsSchema[index - 1];
            customFieldsSchema[index - 1] = temp;
            this.setState({ customFieldsSchema });
        }
    }

    moveFieldDown = (index) => {
        if (index < this.state.customFieldsSchema.length - 1) {
            const customFieldsSchema = [...this.state.customFieldsSchema];
            const temp = customFieldsSchema[index];
            customFieldsSchema[index] = customFieldsSchema[index + 1];
            customFieldsSchema[index + 1] = temp;
            this.setState({ customFieldsSchema });
        }
    }



    render() {
        const { requiredDetailsModalOpen, selectedIntegrationIndex } = this.state;
        const selectedIntegration = this.props.integrations[selectedIntegrationIndex];
        const { integrations, searchIntegration, searchIntegrations, clearSearch, integrationCategories, filterIntegrations, filteredIntegration, toggleIntegration } = this.props;
        return (
            <div className='sectionBody pt-0 mt-25'>
                {!this.state.authenticating ? <div className='flex'>
                    <div className='sectionBlock' style={{ width: 265 }}>

                        <div className="searchbarContainer mb-25">
                            <i className="las la-search" />
                            <input
                                className="searchbar"
                                placeholder="Search..."
                                value={searchIntegration}
                                onChange={searchIntegrations}
                            />
                            <i
                                onClick={clearSearch}
                                className="las la-times-circle"
                                style={{ visibility: searchIntegration == '' ? 'hidden' : 'visible' }}
                            />
                        </div>
                        <div>

                            {integrationCategories.map((category, index) => {
                                return (
                                    <div>
                                        {filteredIntegration == category ? <h3
                                            key={index}
                                            className={`categoryButton ${filteredIntegration == category ? 'selected' : ''}`}
                                            onClick={() => filterIntegrations(category)}
                                        >
                                            {category}
                                        </h3> : <h4
                                            key={index}
                                            className={`categoryButton ${filteredIntegration == category ? 'selected' : ''}`}
                                            onClick={() => filterIntegrations(category)}
                                        >
                                            {category}
                                        </h4>}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className='sectionBlock h-100 ml-25' style={{ maxWidth: 900 }}>
                        <div className='flex' style={{ flexWrap: 'wrap' }}>
                            {integrations && integrations.map((integration, index) => {
                                if ((filteredIntegration == 'All' || filteredIntegration == integration.category || (filteredIntegration == 'Integrated' && integration.enabled) || (filteredIntegration == 'Unintegrated' && !integration.enabled)) && ((searchIntegration != '' && integration.name.toLowerCase().includes(searchIntegration.toLowerCase())) || searchIntegration == '')) {
                                    return (
                                        <div key={index} className={`integrationCard ${integration.enabled ? '' : 'disabled'}`}>
                                            <div className='integrationLogo'>
                                                <img src={integration.logo} />
                                            </div>
                                            <div className='flex-ac flex-sb w-100'>
                                                <h3>{integration.name}</h3>
                                                <div className='flex-ac' style={{ gap: '8px' }}>
                                                    <ToggleField
                                                        checked={integration.enabled}
                                                        onChange={(e) => {
                                                            if ((integration.requiredFields && integration.requiredFields.length > 0 && !integration.enabled)
                                                                || (integration.fields && integration.fields.length > 0 && !integration.enabled)) {
                                                                const { requiredFieldValues, fieldValues, customFieldsSchema, nestedFieldValues } = this.initializeFieldValues(integration);
                                                                this.setState({
                                                                    requiredDetailsModalOpen: true,
                                                                    selectedIntegrationIndex: index,
                                                                    requiredFieldValues,
                                                                    fieldValues,
                                                                    nestedFieldValues,
                                                                    customFieldsSchema,
                                                                });
                                                            } else {
                                                                toggleIntegration(index, e.target.checked)
                                                            }
                                                        }}
                                                        style={{ marginBottom: 0, width: 'min-content' }}
                                                        icons={false}
                                                    />
                                                    {integration.enabled && ((integration.userCredInputs && integration.userCredInputs.length > 0) || (integration.customFields && integration.customFields.length > 0)) && (
                                                        <div style={{ position: 'relative' }}>
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.setState({ openDropdownIndex: this.state.openDropdownIndex === index ? null : index });
                                                                }}
                                                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6c757d', fontSize: '18px', lineHeight: 1, padding: '0 2px' }}
                                                                title="Integration options"
                                                            >
                                                                ···
                                                            </button>
                                                            {this.state.openDropdownIndex === index && (
                                                                <div style={{ position: 'absolute', right: 0, top: 'calc(100% + 4px)', background: '#fff', border: '1px solid #ddd', borderRadius: '6px', zIndex: 200, minWidth: 175 }}>
                                                                    {integration.userCredInputs && integration.userCredInputs.length > 0 && (
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                const integrationData = this.props.integrations[index];
                                                                                const { userCredInputValues } = this.initializeFieldValues(integrationData);
                                                                                this.setState({
                                                                                    credentialsModalOpen: true,
                                                                                    selectedIntegrationIndex: index,
                                                                                    userCredInputValues,
                                                                                    openDropdownIndex: null,
                                                                                });
                                                                            }}
                                                                            style={{ display: 'block', width: '100%', padding: '9px 14px', textAlign: 'left', border: 'none', borderBottom: integration.customFields && integration.customFields.length > 0 ? '1px solid #eee' : 'none', background: 'none', cursor: 'pointer', fontSize: '14px', borderRadius: integration.customFields && integration.customFields.length > 0 ? '6px 6px 0 0' : '6px' }}
                                                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                                        >
                                                                            Update Credentials
                                                                        </button>
                                                                    )}
                                                                    {integration.customFields && integration.customFields.length > 0 && (
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                const integrationData = this.props.integrations[index];
                                                                                const { customFieldsSchema } = this.initializeFieldValues(integrationData);
                                                                                this.setState({
                                                                                    customFieldsModalOpen: true,
                                                                                    selectedIntegrationIndex: index,
                                                                                    customFieldsSchema,
                                                                                    openDropdownIndex: null,
                                                                                });
                                                                            }}
                                                                            style={{ display: 'block', width: '100%', padding: '9px 14px', textAlign: 'left', border: 'none', background: 'none', cursor: 'pointer', fontSize: '14px', borderRadius: integration.userCredInputs && integration.userCredInputs.length > 0 ? '0 0 6px 6px' : '6px' }}
                                                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                                        >
                                                                            Update Custom Fields
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='integrationDescription'>{integration.description}</div>
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    </div>
                </div> :
                    <LoadingWizard text="AUTHENTICATING INTEGRATION" loading={true} />}
                {/* Enable-flow modal: required fields + optional fields shown when enabling an integration */}
                {requiredDetailsModalOpen && <FieldModal
                    isOpen={true}
                    size="medium"
                    modalTitle="Required Fields"
                    toggle={() => this.setState({ requiredDetailsModalOpen: false, requiredFieldValues: {}, selectedIntegrationIndex: null })}
                    cancelOnClick={() => this.setState({ requiredDetailsModalOpen: false, requiredFieldValues: {}, selectedIntegrationIndex: null })}
                    actionButtonLabel="Submit"
                    actionButton={() => {
                        if (selectedIntegration.identifier === "salesforce") {

                            let blacklistEmailsString = this.state.fieldValues['blacklistEmails'];
                            if (blacklistEmailsString) {

                                let blacklistEmails = blacklistEmailsString == '' ? [] : blacklistEmailsString.replace(/ /g, '').split(',');
                                let validBlacklistEmails = true;

                                blacklistEmails = blacklistEmails.map((e) => {
                                    if (!ValidateEmail(e) || '') {
                                        validBlacklistEmails = false;
                                    }

                                    if (e !== '') return e;
                                });

                                if (!validBlacklistEmails) {
                                    this.setState({ invalidBlacklistEmails: true });
                                } else {
                                    this.setState({ invalidBlacklistEmails: false });
                                    // Combine main field values with nested field values for picklist fields
                                    const combinedFieldValues = { ...this.state.fieldValues };
                                    Object.keys(this.state.nestedFieldValues).forEach(fieldId => {
                                        if (this.state.nestedFieldValues[fieldId]) {
                                            combinedFieldValues[fieldId + '_nested'] = this.state.nestedFieldValues[fieldId];
                                        }
                                    });
                                    // Include schema data in custom fields
                                    const processedCustomFields = this.state.customFieldsSchema;
                                    toggleIntegration(selectedIntegrationIndex, true, false, this.state.requiredFieldValues, combinedFieldValues, processedCustomFields);
                                }
                            } else {
                                // Combine main field values with nested field values for picklist fields
                                const combinedFieldValues = { ...this.state.fieldValues, blacklistEmails: '' };
                                Object.keys(this.state.nestedFieldValues).forEach(fieldId => {
                                    if (this.state.nestedFieldValues[fieldId]) {
                                        combinedFieldValues[fieldId + '_nested'] = this.state.nestedFieldValues[fieldId];
                                    }
                                });
                                // Process custom fields to include nestedOptions for backward compatibility

                                const processedCustomFields = this.state.customFieldsSchema;

                                toggleIntegration(selectedIntegrationIndex, true, false, this.state.requiredFieldValues, combinedFieldValues, processedCustomFields);

                            }
                        } else {
                            // For non-Salesforce integrations, include schema data if it exists
                            const combinedFieldValues = this.state.fieldValues;
                            if (Object.keys(this.state.nestedFieldValues).length > 0) {
                                const combined = { ...this.state.fieldValues };
                                Object.keys(this.state.nestedFieldValues).forEach(fieldId => {
                                    if (this.state.nestedFieldValues[fieldId]) {
                                        combined[fieldId + '_nested'] = this.state.nestedFieldValues[fieldId];
                                    }
                                });
                                toggleIntegration(selectedIntegrationIndex, true, false, this.state.requiredFieldValues, combined, this.state.customFieldsSchema);
                            } else {
                                toggleIntegration(selectedIntegrationIndex, true, false, this.state.requiredFieldValues, null, this.state.customFieldsSchema);
                            }
                        }
                    }
                    }
                    bodyContent={() => {
                        return (<>
                            {
                                selectedIntegration != null
                                && selectedIntegration.requiredFields
                                && selectedIntegration.requiredFields.map((field, index) => {
                                    return (
                                        <div key={index} style={{ position: 'relative' }}>
                                            <InputField
                                                label={field.label}
                                                value={this.state.requiredFieldValues[field.id]}
                                                onChange={(e) => {
                                                    const requiredFieldValues = this.state.requiredFieldValues;
                                                    requiredFieldValues[field.id] = e.target.value;
                                                    this.setState({ requiredFieldValues });
                                                }}
                                            />

                                        </div>
                                    );
                                })
                            }
                            {
                                selectedIntegration != null
                                && selectedIntegration.fields
                                && selectedIntegration.fields.map((field, index) => {
                                    let errorMessage = '';
                                    let errorTrigger = false;
                                    if (field.id === 'blacklistEmails') {
                                        errorMessage = 'Please enter valid emails separated by commas';
                                        errorTrigger = this.state.invalidBlacklistEmails;
                                    }

                                    // Handle picklist fields with nested options
                                    if (field.type === 'picklist') {
                                        const selectedValue = this.state.fieldValues[field.id];
                                        const nestedValue = this.state.nestedFieldValues[field.id];
                                        const nestedOptions = field.nestedOptions && field.nestedOptions[selectedValue] ? field.nestedOptions[selectedValue] : [];

                                        return (
                                            <div key={index}>
                                                <SelectField
                                                    label={field.label}
                                                    value={selectedValue ? { value: selectedValue, label: field.options.find(opt => opt.value === selectedValue)?.label || selectedValue } : null}
                                                    options={field.options || []}
                                                    onChange={(selectedOption) => {
                                                        const fieldValues = { ...this.state.fieldValues };
                                                        const nestedFieldValues = { ...this.state.nestedFieldValues };
                                                        fieldValues[field.id] = selectedOption ? selectedOption.value : '';
                                                        // Clear nested value when main selection changes
                                                        nestedFieldValues[field.id] = '';
                                                        this.setState({ fieldValues, nestedFieldValues });
                                                    }}
                                                    placeholder={`Select ${field.label}`}
                                                />
                                                {selectedValue && nestedOptions.length > 0 && (
                                                    <div style={{ marginTop: '15px' }}>
                                                        <SelectField
                                                            label={`${field.label} Sub-Type`}
                                                            value={nestedValue ? { value: nestedValue, label: nestedOptions.find(opt => opt.value === nestedValue)?.label || nestedValue } : null}
                                                            options={nestedOptions}
                                                            onChange={(selectedOption) => {
                                                                const nestedFieldValues = { ...this.state.nestedFieldValues };
                                                                nestedFieldValues[field.id] = selectedOption ? selectedOption.value : '';
                                                                this.setState({ nestedFieldValues });
                                                            }}
                                                            placeholder={`Select ${field.label} sub-type`}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }

                                    // Default to InputField for other field types
                                    return (
                                        <div key={index} style={{ position: 'relative' }}>
                                            <InputField
                                                label={field.label}
                                                value={this.state.fieldValues[field.id]}
                                                onChange={(e) => {
                                                    const fieldValues = this.state.fieldValues;
                                                    fieldValues[field.id] = e.target.value;
                                                    this.setState({ fieldValues });
                                                }}
                                                errorMessage={errorMessage}
                                                errorTrigger={errorTrigger}
                                            />

                                        </div>
                                    );
                                })
                            }
                            {selectedIntegration.identifier === 'salesforce' && <div className='mt-25'>
                                <div className='flex-ac flex-sb mb-15'>
                                    <h3>Custom Fields Schema Builder</h3>
                                    <button
                                        onClick={this.addCustomFieldToSchema}
                                        className="neu">
                                        Add Field
                                    </button>
                                </div>

                                {/* Schema Builder */}
                                {this.state.customFieldsSchema.map((field, index) => (
                                    <div key={index} className='mb-15' style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
                                        <div className='flex mb-15' style={{ gap: '15px', alignItems: 'flex-end' }}>
                                            <div className='flex flex-column' style={{ gap: '5px', marginRight: '10px' }}>
                                                <button
                                                    onClick={() => this.moveFieldUp(index)}
                                                    disabled={index === 0}
                                                    className="neu"
                                                    style={{
                                                        padding: '2px 6px',
                                                        opacity: index === 0 ? 0.5 : 1,
                                                        cursor: index === 0 ? 'not-allowed' : 'pointer'
                                                    }}
                                                    title="Move up"
                                                >
                                                    <i className="las la-arrow-up" />
                                                </button>
                                                <button
                                                    onClick={() => this.moveFieldDown(index)}
                                                    disabled={index === this.state.customFieldsSchema.length - 1}
                                                    className="neu"
                                                    style={{
                                                        padding: '2px 6px',
                                                        opacity: index === this.state.customFieldsSchema.length - 1 ? 0.5 : 1,
                                                        cursor: index === this.state.customFieldsSchema.length - 1 ? 'not-allowed' : 'pointer'
                                                    }}
                                                    title="Move down"
                                                >
                                                    <i className="las la-arrow-down" />
                                                </button>
                                            </div>
                                            <InputField
                                                label="Field Label"
                                                value={field.label}
                                                onChange={(e) => this.updateCustomFieldSchema(index, 'label', e.target.value)}
                                                style={{ flex: 1 }}
                                            />
                                            <InputField
                                                label="ID"
                                                value={field.id}
                                                onChange={(e) => this.updateCustomFieldSchema(index, 'id', e.target.value)}
                                                style={{ flex: 1 }}
                                            />
                                            <SelectField
                                                label="Field Type"
                                                value={field.type ? { value: field.type, label: field.type } : null}
                                                options={[
                                                    { value: 'text', label: 'Text' },
                                                    { value: 'date', label: 'Date' },
                                                    { value: 'boolean', label: 'Boolean' },
                                                    { value: 'select', label: 'Select' },
                                                    { value: 'multiSelectPicklist', label: 'Multi Select Picklist' },
                                                    { value: 'nestedSection', label: 'Nested Section' },
                                                    { value: 'sfcontactsearch', label: 'SF Contact Search' },
                                                    { value: 'sfaccountsearch', label: 'SF Account Search' }
                                                ]}
                                                onChange={(selectedOption) => this.updateCustomFieldSchema(index, 'type', selectedOption ? selectedOption.value : '')}
                                                style={{ flex: 1 }}
                                            />
                                            <div className="m-a" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <ToggleField
                                                    label="Required"
                                                    checked={field.required || false}
                                                    onChange={(e) => this.updateCustomFieldSchema(index, 'required', e.target.checked)}
                                                    style={{ marginBottom: 0 }}
                                                    icons={false}
                                                />
                                            </div>
                                            <button
                                                onClick={() => {
                                                    const customFieldsSchema = this.state.customFieldsSchema.filter((_, i) => i !== index);
                                                    this.setState({ customFieldsSchema });
                                                }}
                                                className="neu m-a"
                                                style={{ padding: '5px 10px', backgroundColor: '#dc3545', color: 'white' }}
                                            >
                                                Remove
                                            </button>
                                        </div>

                                        {field.type === 'select' && (
                                            <div className='ml-15'>
                                                <div className='flex-ac flex-sb mb-10'>
                                                    <h5>Select Options</h5>
                                                    <button
                                                        onClick={() => this.addOptionToNestedSection(index)}
                                                        className="neu"
                                                        style={{ padding: '3px 8px', fontSize: '12px' }}
                                                    >
                                                        Add Option
                                                    </button>
                                                </div>
                                                {field.options && field.options.map((option, optionIndex) => (
                                                    <div key={optionIndex} className='flex mb-10' style={{ gap: '10px', alignItems: 'center' }}>
                                                        <InputField

                                                            value={option.label}
                                                            onChange={(e) => this.updateNestedSectionOption(index, optionIndex, 'label', e.target.value)}
                                                            style={{ flex: 1 }}
                                                        />
                                                        <button
                                                            onClick={() => this.removeNestedSectionOption(index, optionIndex)}
                                                            className="neu "
                                                            style={{ marginBottom: '12px', fontSize: '12px', backgroundColor: '#dc3545', color: 'white', width: '0px' }}
                                                        >
                                                            <i className=" las la-times" />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {field.type === 'multiSelectPicklist' && (
                                            <div className='ml-15'>
                                                <div className='flex-ac flex-sb mb-10'>
                                                    <h5>Multi Select Options</h5>
                                                    <button
                                                        onClick={() => this.addOptionToNestedSection(index)}
                                                        className="neu"
                                                        style={{ padding: '3px 8px', fontSize: '12px' }}
                                                    >
                                                        Add Option
                                                    </button>
                                                </div>
                                                {field.options && field.options.map((option, optionIndex) => (
                                                    <div key={optionIndex} className='flex mb-10' style={{ gap: '10px', alignItems: 'center' }}>
                                                        <InputField

                                                            value={option.label}
                                                            onChange={(e) => this.updateNestedSectionOption(index, optionIndex, 'label', e.target.value)}
                                                            style={{ flex: 1 }}
                                                        />
                                                        <button
                                                            onClick={() => this.removeNestedSectionOption(index, optionIndex)}
                                                            className="neu "
                                                            style={{ marginBottom: '12px', fontSize: '12px', backgroundColor: '#dc3545', color: 'white', width: '0px' }}
                                                        >
                                                            <i className=" las la-times" />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {field.type === 'nestedSection' && (
                                            <div className='ml-15'>
                                                <div className='flex-ac flex-sb mb-10'>
                                                    <h5>Section Options</h5>
                                                    <button
                                                        onClick={() => this.addOptionToNestedSection(index)}
                                                        className="neu"
                                                        style={{ padding: '3px 8px', fontSize: '12px' }}
                                                    >
                                                        Add Option
                                                    </button>
                                                </div>
                                                {field.options && field.options.map((option, optionIndex) => (
                                                    <div key={optionIndex} className='flex mb-10' style={{ gap: '10px', alignItems: 'center' }}>
                                                        <InputField
                                                            label="Label"
                                                            value={option.label}
                                                            onChange={(e) => this.updateNestedSectionOption(index, optionIndex, 'label', e.target.value)}
                                                            style={{ flex: 1 }}
                                                        />
                                                        <SelectField
                                                            label="Type"
                                                            value={option.type ? { value: option.type, label: option.type } : null}
                                                            options={[
                                                                { value: 'text', label: 'Text' },
                                                                { value: 'date', label: 'Date' }
                                                            ]}
                                                            onChange={(selectedOption) => this.updateNestedSectionOption(index, optionIndex, 'type', selectedOption ? selectedOption.value : '')}
                                                            style={{ flex: 1 }}
                                                        />
                                                        <button
                                                            onClick={() => this.removeNestedSectionOption(index, optionIndex)}
                                                            className="neu "
                                                            style={{ marginTop: '5px', width: '0px', fontSize: '12px', backgroundColor: '#dc3545', color: 'white' }}
                                                        >
                                                            <i className=" las la-times" />
                                                        </button>
                                                    </div>
                                                ))}

                                                <div className='mt-15'>
                                                    <h5>Trigger Options</h5>
                                                    {field.options && field.options.map((option, optionIndex) => (
                                                        <div key={`trigger-${optionIndex}`} className='mb-10' style={{ padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '3px' }}>
                                                            <div className='flex-ac flex-sb mb-5'>
                                                                <span style={{ fontWeight: 'bold' }}>When "{option.label}" is selected:</span>
                                                                <button
                                                                    onClick={() => this.addTriggerOption(index, option.label)}
                                                                    className="neu"
                                                                    style={{ padding: '2px 6px', fontSize: '11px' }}
                                                                >
                                                                    Add Trigger
                                                                </button>
                                                            </div>
                                                            {field.triggerOptions && field.triggerOptions[option.label] && field.triggerOptions[option.label].map((trigger, triggerIndex) => (
                                                                <div key={triggerIndex} className='mb-10'>
                                                                    <div className='flex mb-5' style={{ gap: '15px', alignItems: 'flex-end' }}>
                                                                        <InputField
                                                                            label="Label"
                                                                            value={trigger.label}
                                                                            onChange={(e) => this.updateTriggerOption(index, option.label, triggerIndex, 'label', e.target.value)}
                                                                            style={{ flex: 1 }}
                                                                        />
                                                                        <InputField
                                                                            label="ID"
                                                                            value={trigger.id}
                                                                            onChange={(e) => this.updateTriggerOption(index, option.label, triggerIndex, 'id', e.target.value)}
                                                                            style={{ flex: 1 }}
                                                                        />
                                                                        <SelectField
                                                                            label="Type"
                                                                            value={trigger.type ? { value: trigger.type, label: trigger.type } : null}
                                                                            options={[
                                                                                { value: 'text', label: 'Text' },
                                                                                { value: 'date', label: 'Date' },
                                                                                { value: 'boolean', label: 'Boolean' },
                                                                                { value: 'select', label: 'Select' }
                                                                            ]}
                                                                            onChange={(selectedOption) => this.updateTriggerOption(index, option.label, triggerIndex, 'type', selectedOption ? selectedOption.value : '')}
                                                                            style={{ flex: 1 }}
                                                                        />
                                                                        <button onClick={() => this.removeTriggerOption(index, option.label, triggerIndex)}
                                                                            style={{ marginBottom: '17px', fontSize: '10px', backgroundColor: '#dc3545', color: 'white', width: '0px' }}

                                                                        >
                                                                            <i

                                                                                className=" las la-times"
                                                                            >
                                                                            </i>
                                                                        </button>
                                                                    </div>
                                                                    {trigger.type === 'select' && (
                                                                        <div className='ml-10 flex flex-column gap5'>
                                                                            <div className='flex-ac flex-sb mb-5'>
                                                                                <span style={{ fontSize: '12px', fontWeight: 'bold' }}>Select Options:</span>
                                                                                <button
                                                                                    onClick={() => this.addTriggerOption(index, `${option.label}_${triggerIndex}`)}
                                                                                    className="neu"
                                                                                    style={{ padding: '1px 4px', fontSize: '10px' }}
                                                                                >
                                                                                    Add Option
                                                                                </button>
                                                                            </div>
                                                                            {trigger.options && trigger.options.map((selectOption, selectOptionIndex) => (
                                                                                <div key={selectOptionIndex} className='flex' style={{ gap: '10px', alignItems: 'center' }}>
                                                                                    <InputField
                                                                                        label=""
                                                                                        value={selectOption.label}
                                                                                        onChange={(e) => this.updateTriggerOption(index, `${option.label}_${triggerIndex}`, selectOptionIndex, 'label', e.target.value)}
                                                                                        style={{ flex: 1 }}
                                                                                        placeholder="Option label"
                                                                                    />
                                                                                    <button
                                                                                        onClick={() => this.removeTriggerOption(index, `${option.label}_${triggerIndex}`, selectOptionIndex)}
                                                                                        className="neu "
                                                                                        style={{ marginBottom: '12px', fontSize: '10px', backgroundColor: '#dc3545', color: 'white', width: '0px' }}
                                                                                    >
                                                                                        <i className=" las la-times" />
                                                                                    </button>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}

                            </div>}
                        </>)
                    }} />}
                {/* Credentials modal: update user-defined credential inputs without exposing other creds */}
                {this.state.credentialsModalOpen && selectedIntegration && (
                    <FieldModal
                        isOpen={true}
                        size="medium"
                        modalTitle="Update Credentials"
                        toggle={() => this.setState({ credentialsModalOpen: false, userCredInputValues: {}, selectedIntegrationIndex: null })}
                        cancelOnClick={() => this.setState({ credentialsModalOpen: false, userCredInputValues: {}, selectedIntegrationIndex: null })}
                        actionButtonLabel="Save"
                        actionButton={() => {
                            toggleIntegration(selectedIntegrationIndex, true, false, null, null, null, this.state.userCredInputValues);
                            this.setState({ credentialsModalOpen: false, userCredInputValues: {} });
                        }}
                        bodyContent={() => (
                            <div>
                                <p style={{ marginBottom: '20px', color: '#6c757d', fontSize: '14px' }}>
                                    Update the credential values for this integration. Only these fields will be modified.
                                </p>
                                {selectedIntegration.userCredInputs && selectedIntegration.userCredInputs.map((input, idx) => (
                                    <div key={idx}>
                                        <InputField
                                            label={input.label}
                                            value={this.state.userCredInputValues[input.key] || ''}
                                            onChange={(e) => {
                                                const userCredInputValues = { ...this.state.userCredInputValues };
                                                userCredInputValues[input.key] = e.target.value;
                                                this.setState({ userCredInputValues });
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    />
                )}
                {/* Custom fields modal: edit the custom fields schema for this integration */}
                {this.state.customFieldsModalOpen && selectedIntegration && (
                    <FieldModal
                        isOpen={true}
                        size="medium"
                        modalTitle="Update Custom Fields"
                        toggle={() => this.setState({ customFieldsModalOpen: false, selectedIntegrationIndex: null })}
                        cancelOnClick={() => this.setState({ customFieldsModalOpen: false, selectedIntegrationIndex: null })}
                        actionButtonLabel="Save"
                        actionButton={() => {
                            toggleIntegration(selectedIntegrationIndex, true, false, null, null, this.state.customFieldsSchema);
                            this.setState({ customFieldsModalOpen: false });
                        }}
                        bodyContent={() => (
                            <div>
                                <div className='flex-ac flex-sb mb-15'>
                                    <h3>Custom Fields Schema Builder</h3>
                                    <button onClick={this.addCustomFieldToSchema} className="neu">Add Field</button>
                                </div>
                                {this.state.customFieldsSchema.map((field, index) => (
                                    <div key={index} className='mb-15' style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
                                        <div className='flex mb-15' style={{ gap: '15px', alignItems: 'flex-end' }}>
                                            <div className='flex flex-column' style={{ gap: '5px', marginRight: '10px' }}>
                                                <button onClick={() => this.moveFieldUp(index)} disabled={index === 0} className="neu" style={{ padding: '2px 6px', opacity: index === 0 ? 0.5 : 1 }} title="Move up"><i className="las la-arrow-up" /></button>
                                                <button onClick={() => this.moveFieldDown(index)} disabled={index === this.state.customFieldsSchema.length - 1} className="neu" style={{ padding: '2px 6px', opacity: index === this.state.customFieldsSchema.length - 1 ? 0.5 : 1 }} title="Move down"><i className="las la-arrow-down" /></button>
                                            </div>
                                            <InputField label="Field Label" value={field.label} onChange={(e) => this.updateCustomFieldSchema(index, 'label', e.target.value)} style={{ flex: 1 }} />
                                            <InputField label="ID" value={field.id} onChange={(e) => this.updateCustomFieldSchema(index, 'id', e.target.value)} style={{ flex: 1 }} />
                                            <SelectField
                                                label="Field Type"
                                                value={field.type ? { value: field.type, label: field.type } : null}
                                                options={[
                                                    { value: 'text', label: 'Text' },
                                                    { value: 'date', label: 'Date' },
                                                    { value: 'boolean', label: 'Boolean' },
                                                    { value: 'select', label: 'Select' },
                                                    { value: 'multiSelectPicklist', label: 'Multi Select Picklist' },
                                                    { value: 'nestedSection', label: 'Nested Section' },
                                                    { value: 'sfcontactsearch', label: 'SF Contact Search' },
                                                    { value: 'sfaccountsearch', label: 'SF Account Search' }
                                                ]}
                                                onChange={(selectedOption) => this.updateCustomFieldSchema(index, 'type', selectedOption ? selectedOption.value : '')}
                                                style={{ flex: 1 }}
                                            />
                                            <div className="m-a" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <ToggleField label="Required" checked={field.required || false} onChange={(e) => this.updateCustomFieldSchema(index, 'required', e.target.checked)} style={{ marginBottom: 0 }} icons={false} />
                                            </div>
                                            <button
                                                onClick={() => { const customFieldsSchema = this.state.customFieldsSchema.filter((_, i) => i !== index); this.setState({ customFieldsSchema }); }}
                                                className="neu m-a"
                                                style={{ padding: '5px 10px', backgroundColor: '#dc3545', color: 'white' }}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    />
                )}
            </div>
        );
    }
}

export default withRouter(Integrations);
